import React, { useEffect } from 'react'
import { useRecoilValue } from 'recoil'

import { TruncateAndTooltip, PageHeader, Flex } from 'mailup-web-components'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import styled from '@emotion/styled'
import { useIntl } from 'react-intl'
import { pageState } from '../recoil/state/page'
import SaveRowButton from './SaveRowButton'

const Header = () => {
  const [redirectUrl] = useRedirectorUrl()
  const intl = useIntl()
  const { title } = useRecoilValue(pageState)

  useEffect(() => {
    // TODO
    // notifyParent('selectMenuItemReact', ['EmailMessageBeeEdit', redirectUrl])
  }, [redirectUrl])

  const ControlsComponent = () => {
    return (
      <Flex alignItems='center' gap='8px;'>
        <SaveRowButton />
      </Flex>
    )
  }
  
  return (
    <>
      <StyledHeader
        title={<TruncateAndTooltip text={title} forceTooltipRebuild />}
        breadcrumbsItems={[]}
        ControlsComponent={ControlsComponent}
      />
    </>
  )
}

export default Header

const StyledHeader = styled(PageHeader)`
  height: 60px;
  z-index: 1000;
  padding: 10px;
  padding-left: 20px;
  width: 100%;

  .b-page-header__wrapper {
    max-width: 100%;
  }
  h1 {
    flex-basis: 50%;
  }
  .b-page-header__controls {
    flex-basis: 50%;
  }
`
